var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarousal4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2142,
    height: 2235,
    viewBox: "0 0 2142 2235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1575.82 1926.8C1575.52 1925.63 1580.25 1929.52 1512.14 1877.55C1456.01 1834.71 1389.87 1783.84 1324.58 1731.05C1333.67 1671.34 1357.31 1575.39 1362 1456.63C1366.25 1349.29 1329.42 1297 1244.04 1223.45C1155.76 1211.8 1097.98 1216.03 1010.29 1225.08C932.868 1308.92 860.267 1397.09 792.835 1489.15C807.52 1552.66 799.23 1619.3 769.436 1677.26C739.643 1735.23 690.273 1780.76 630.092 1805.79L572.639 2023.09C616.921 2063.26 722.716 2079.85 774.013 2064.58C774.614 2063.4 859.199 1748.96 857.375 1756.88C860.729 1742.31 856.316 1755.6 959.194 1629.35C1078.77 1482.64 1116.45 1425 1116.45 1425C1116.45 1425 1110.84 1697.63 1120.69 1746.03C1133.64 1809.74 1165.42 1844.47 1204.91 1879.14C1328.19 1987.38 1439.33 2064.72 1456.88 2079.78C1535.97 2059.76 1588.49 1977.28 1575.82 1926.8Z",
    fill: "#A7ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.85 146.322L903.553 359.916H1238.15L1070.85 146.322Z",
    fill: "#A7ECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.07 1209.21L847.983 1080.66L822.64 1112.2L990.681 1247.15C998.285 1238.75 1004.81 1231.51 1010.26 1225.08C1009.64 1219.41 1008.88 1214.2 1008.07 1209.21Z",
    fill: "#A7ECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M991.822 878.035C1017.54 874.08 1066.33 861.226 1076.01 821.664C1078.74 808.089 1079.93 794.249 1079.54 780.407C1079.54 776.805 1079.61 773.227 1079.7 769.661C1065.14 773.415 1054.98 769.661 1050.76 755.536C1044.1 733.171 1054.29 678.107 1061.64 666.077C1073.01 647.314 1098.2 649.692 1103.4 677.177C1104.65 683.839 1107.79 700.507 1109.01 706.251C1110.7 702.979 1113.3 700.265 1116.5 698.442C1119.7 696.618 1123.36 695.761 1127.03 695.975C1136.65 697.894 1135.72 710.712 1128.78 718.469C1126.94 720.711 1124.61 722.511 1121.98 723.734C1119.35 724.956 1116.48 725.57 1113.58 725.532C1119.71 750.332 1128.69 774.342 1140.32 797.087C1162.69 839.391 1190.61 861.826 1225.41 865.169C1262.98 866.32 1300.38 870.596 1337.24 877.952C1345.48 879.73 1353.72 881.684 1361.96 883.755C1327.59 854.961 1295.78 823.238 1266.91 788.941C1219.74 730.287 1208.24 676.023 1163.61 637.097C1107.72 588.283 1019.87 590.355 1017.65 704.909C1016.92 743.176 1012.63 782.102 993.023 815.802C973.73 845.418 947.335 869.737 916.242 886.545C903.988 894.031 899.197 896.986 893.547 900.082C931.402 891.324 971.353 882.26 991.822 878.035Z",
    fill: "#6095B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.32 793.978C1087.48 780.82 1097.05 768.587 1107.86 757.488C1099.08 762.798 1089.61 766.888 1079.73 769.648C1079.63 773.179 1079.61 776.851 1079.57 780.394C1079.53 784.891 1079.47 789.434 1079.32 793.978Z",
    fill: "#6095B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.62 369.862C1909.62 364.877 1902.85 362.077 1895.79 362.077C1888.73 362.077 1881.96 364.877 1876.95 369.862L1749.85 496.905C1745.29 501.984 1742.85 508.618 1743.04 515.443C1743.21 522.267 1746 528.761 1750.84 533.588C1755.67 538.415 1762.15 541.208 1768.98 541.391C1775.81 541.574 1782.44 539.133 1787.52 534.572L1914.56 407.529C1919.55 402.537 1922.37 395.769 1922.38 388.708C1922.39 381.647 1919.6 374.87 1914.62 369.862Z",
    fill: "#6095B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M974.107 1006.21L945.374 1023.93C945.052 1024.13 944.781 1024.4 944.587 1024.73C944.392 1025.05 944.277 1025.42 944.255 1025.8C944.231 1026.17 944.3 1026.55 944.454 1026.9C944.608 1027.24 944.842 1027.55 945.139 1027.78L963.584 1042.59C963.882 1042.83 964.234 1042.99 964.609 1043.07C964.985 1043.14 965.372 1043.12 965.738 1043.01C966.104 1042.9 966.438 1042.7 966.711 1042.43C966.983 1042.17 967.187 1041.84 967.304 1041.47L977.591 1008.92C977.738 1008.47 977.741 1007.97 977.599 1007.51C977.457 1007.05 977.178 1006.65 976.798 1006.35C976.418 1006.05 975.956 1005.88 975.475 1005.85C974.993 1005.83 974.516 1005.95 974.107 1006.21Z",
    fill: "#6095B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.21 1030.08C1239.23 1026.32 1219.39 1020.96 1219.38 1020.96C1218.91 1020.83 1218.4 1020.85 1217.94 1021.03C1217.48 1021.2 1217.08 1021.51 1216.81 1021.92C1216.54 1022.33 1216.4 1022.81 1216.41 1023.31C1216.42 1023.8 1216.6 1024.27 1216.89 1024.66L1250.32 1068.09C1250.62 1068.47 1251.02 1068.75 1251.48 1068.89C1251.95 1069.04 1252.43 1069.04 1252.89 1068.89C1253.35 1068.75 1253.76 1068.46 1254.05 1068.08C1254.35 1067.7 1254.51 1067.24 1254.54 1066.76L1255.98 1032.47C1256.01 1031.93 1255.84 1031.39 1255.52 1030.96C1255.19 1030.52 1254.74 1030.21 1254.21 1030.08Z",
    fill: "#6095B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8846 1968.12C44.4478 1975.56 40.2715 1985.65 40.2727 1996.16C40.2739 2006.68 44.4525 2016.77 51.8905 2024.21C59.3285 2031.64 69.415 2035.81 79.9322 2035.81C90.4507 2035.81 100.536 2031.64 107.973 2024.2L299.12 1833.05C302.803 1829.37 305.723 1825 307.717 1820.18C309.71 1815.37 310.735 1810.21 310.735 1805.01C310.735 1799.8 309.71 1794.64 307.717 1789.83C305.723 1785.01 302.803 1780.65 299.12 1776.96C295.436 1773.28 291.065 1770.36 286.253 1768.37C281.441 1766.37 276.284 1765.34 271.076 1765.34C265.867 1765.34 260.71 1766.37 255.898 1768.37C251.086 1770.36 246.715 1773.28 243.031 1776.96L51.8846 1968.12Z",
    fill: "#6095B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.21 1357.67C1097.21 1357.67 1091.8 1439.46 1091.79 1459.81C1099.36 1450.24 1116.45 1425 1116.45 1425C1112.86 1401.85 1106.39 1379.22 1097.21 1357.67Z",
    fill: "#6095B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1665.39 2222.96L1634.16 1978.13L1577.49 1937.81C1580.66 1983 1540.8 2045.68 1479.97 2072C1500.85 2092.81 1574.02 2164.48 1624.01 2197.53C1642.41 2209.6 1655.75 2217.65 1665.39 2222.96Z",
    fill: "#6095B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M731.498 2203.94L759.43 2067.84C711.04 2075.74 633.706 2063.33 588.518 2034.97L562.622 2113.91C507.517 2131.92 457.486 2162.77 416.663 2203.94H731.498Z",
    fill: "#6095B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.82 1271.62C1537.78 1271.62 1547.47 1261.93 1547.47 1249.97C1547.47 1238.01 1537.78 1228.32 1525.82 1228.32C1513.86 1228.32 1504.17 1238.01 1504.17 1249.97C1504.17 1261.93 1513.86 1271.62 1525.82 1271.62Z",
    fill: "#6095B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.82 1926.8C1575.52 1925.63 1580.25 1929.52 1512.14 1877.56C1456.01 1834.71 1389.87 1783.84 1324.58 1731.06C1333.67 1671.34 1357.31 1575.39 1362 1456.63C1366.25 1349.29 1329.42 1297.01 1244.04 1223.45C1155.76 1211.8 1097.98 1216.03 1010.29 1225.09C932.868 1308.92 860.267 1397.09 792.835 1489.15C807.52 1552.66 799.23 1619.3 769.436 1677.26C739.643 1735.23 690.273 1780.76 630.092 1805.79L572.639 2023.09C616.921 2063.26 722.716 2079.85 774.013 2064.58C774.614 2063.41 859.199 1748.96 857.375 1756.88C860.729 1742.31 856.316 1755.6 959.194 1629.36C1078.77 1482.64 1116.45 1425 1116.45 1425C1116.45 1425 1110.84 1697.63 1120.69 1746.03C1133.64 1809.74 1165.42 1844.47 1204.91 1879.14C1328.19 1987.38 1439.33 2064.72 1456.88 2079.78C1535.97 2059.76 1588.49 1977.28 1575.82 1926.8Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M599.936 747.589L1070.85 146.322L1434.15 610.176",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.342 1511.02H2L307.502 1120.96",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M446.198 943.881L352.922 1062.97",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.22 1511.02H1053.22",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1843.3 1132.59L2139.7 1511.02H1358.47",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1633.9 865.227L1739.28 999.767",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.26 1225.09C1097.95 1216.03 1155.66 1211.8 1244 1223.45C1248.14 1137.64 1247.53 1177.54 1253.63 1032.36C1269.53 1036.5 1299.35 1044.13 1364.06 1060.05L1366.5 1060.65C1420.21 1073.91 1477.49 1088.1 1535.28 1102.94C1607.97 1121.61 1685.04 1142.16 1757.49 1161.79C1789.42 1120.78 1804.88 1069.34 1800.88 1017.53C1665.37 978.862 1646.03 971.988 1462.81 913.699C1421.98 900.68 1379.77 887.226 1337.24 877.998C1300.38 870.642 1262.98 866.366 1225.41 865.215C1209.41 943.197 1152.06 997.437 1074.67 970.387C1032.29 955.556 1006.88 920.608 991.788 878.08C953.333 886.085 846.065 910.921 813.154 918.866L964.998 1040.81C956.542 1064.24 957.568 1090.05 967.858 1112.73C984.49 1148 1003.05 1161.52 1010.26 1225.09Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.99 115.859L1070.85 2H1339.12",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.9 869.96C1691.41 869.96 1771.28 790.098 1771.28 691.584C1771.28 593.071 1691.41 513.209 1592.9 513.209C1494.39 513.209 1414.53 593.071 1414.53 691.584C1414.53 790.098 1494.39 869.96 1592.9 869.96Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1504.44 791.27C1489.58 778.116 1477.84 761.802 1470.11 743.524C1462.36 725.246 1458.82 705.468 1459.71 685.639",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.04 565.446L1749.85 534.63",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.62 369.862C1909.62 364.877 1902.85 362.077 1895.79 362.077C1888.73 362.077 1881.96 364.877 1876.96 369.862L1749.85 496.905C1745.3 501.984 1742.85 508.618 1743.04 515.443C1743.21 522.267 1746.02 528.761 1750.84 533.588C1755.67 538.415 1762.15 541.208 1768.98 541.391C1775.81 541.574 1782.45 539.133 1787.52 534.572L1914.56 407.529C1919.55 402.537 1922.37 395.769 1922.38 388.708C1922.39 381.647 1919.6 374.87 1914.62 369.862Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M921.491 1325.51L375.877 887.426C363.113 877.177 352.492 864.514 344.622 850.161C336.752 835.806 331.786 820.044 330.007 803.771C328.229 787.498 329.673 771.034 334.258 755.319C338.843 739.604 346.477 724.946 356.726 712.182C366.975 699.418 379.638 688.798 393.991 680.927C408.346 673.057 424.109 668.091 440.382 666.312C456.655 664.534 473.119 665.978 488.834 670.563C504.548 675.147 519.206 682.782 531.97 693.031L965.067 1040.77",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.26 1225.09C1009.61 1219.41 1008.88 1214.14 1008.07 1209.21L555.548 845.864C551.361 842.504 546.012 840.946 540.676 841.531C535.341 842.116 530.456 844.796 527.098 848.983C523.738 853.169 522.18 858.518 522.765 863.854C523.35 869.189 526.03 874.074 530.217 877.433L990.681 1247.16C998.285 1238.75 1004.78 1231.51 1010.26 1225.09Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M573.156 940.338L553.204 965.186",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M690.948 1034.92L670.996 1059.76",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M808.739 1129.49L788.787 1154.34",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M926.528 1224.07L906.577 1248.92",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M626.255 874.209L646.207 849.36",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M744.046 968.787L763.998 943.938",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M861.837 1063.37L881.788 1038.52",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M979.628 1157.94L987.373 1148.3",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M449.351 1019.17C394.588 1039.72 342.367 1066.49 293.717 1098.96C281.954 1107.31 270.766 1116.44 260.229 1126.29C253.59 1132.55 257.298 1142.3 270.622 1135.86C287.243 1128.32 304.329 1121.85 321.779 1116.5C341.072 1110.02 360.68 1104.52 380.527 1100.02C397.418 1096.25 413.014 1097.35 412.732 1114.65C410.758 1129.13 404.03 1142.54 393.604 1152.78C390.473 1156.66 387.248 1160.69 384.494 1164.69C375.901 1177.15 386.848 1185.88 396.959 1178.21C404.175 1172.78 411.084 1166.84 417.876 1161.1C432.476 1147.48 448.229 1135.14 464.959 1124.24",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M510.76 995.718L449.893 1011.67C444.76 1063.31 461.84 1128.93 479.437 1155.27C540.646 1143.36 596.275 1130.24 659.284 1114.97",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M350.476 1135.18C347.121 1140.69 337.61 1162.09 335.174 1167.94C331.772 1176.11 337.916 1185.13 349.546 1171.4C357.039 1162.98 365.098 1155.08 373.664 1147.76C381.416 1141.5 389.52 1135.69 397.936 1130.35C403.821 1126.62 407.6 1124.47 411.731 1122.24",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M326.475 1115.22C316.768 1127.48 308.421 1140.77 301.58 1154.84C292.163 1172.58 303.557 1178.45 314.728 1167.16C337.834 1144.8 370.31 1118.45 396.147 1098.28",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M524.637 1826.69C676.655 1826.69 799.887 1703.46 799.887 1551.44C799.887 1399.42 676.655 1276.19 524.637 1276.19C372.622 1276.19 249.388 1399.42 249.388 1551.44C249.388 1703.46 372.622 1826.69 524.637 1826.69Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M665.016 1443.2C652.174 1432.51 636.475 1425.83 619.867 1423.97C603.258 1422.12 586.472 1425.19 571.591 1432.79C561.395 1438 552.325 1445.16 544.902 1453.88C537.479 1462.6 531.849 1472.69 528.333 1483.58C526.617 1489.09 525.346 1494.72 524.531 1500.43C522.962 1486.15 517.856 1472.48 509.675 1460.68C501.496 1448.87 490.501 1439.28 477.683 1432.79C462.804 1425.19 446.017 1422.12 429.409 1423.97C412.801 1425.83 397.101 1432.51 384.258 1443.2C371.705 1452.72 362.216 1465.7 356.97 1480.56C351.722 1495.41 350.947 1511.48 354.737 1526.77C360.905 1549.88 378.961 1577.86 408.424 1609.96C443.998 1647.53 482.894 1681.79 524.637 1712.36C566.386 1681.79 605.285 1647.53 640.863 1609.96C670.29 1577.86 688.37 1549.93 694.538 1526.77C698.329 1511.48 697.553 1495.41 692.306 1480.56C687.06 1465.7 677.571 1452.72 665.016 1443.2Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M447.421 1570.63H501.202L526.58 1545.25V1605.2L561.151 1570.63H589",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8846 1968.12C44.4478 1975.56 40.2715 1985.65 40.2727 1996.16C40.2739 2006.68 44.4525 2016.77 51.8905 2024.21C59.3285 2031.64 69.415 2035.81 79.9322 2035.81C90.4507 2035.81 100.536 2031.64 107.973 2024.2L299.12 1833.05C302.803 1829.37 305.723 1825 307.717 1820.18C309.71 1815.37 310.735 1810.21 310.735 1805.01C310.735 1799.8 309.71 1794.64 307.717 1789.83C305.723 1785.01 302.803 1780.65 299.12 1776.96C295.436 1773.28 291.065 1770.36 286.253 1768.37C281.441 1766.37 276.284 1765.34 271.076 1765.34C265.867 1765.34 260.71 1766.37 255.898 1768.37C251.086 1770.36 246.715 1773.28 243.031 1776.96L51.8846 1968.12Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M330.018 1746.07L299.12 1776.96",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0791 1662.21L148.182 1769.31",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0791 1769.31L148.182 1662.21",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M921.833 2006.59V2123.57",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M980.322 2065.08H863.344",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1932.27 1887.64L1997.22 1952.59",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1932.27 1952.59L1997.22 1887.64",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M223.127 851.138L261.053 889.063",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M223.127 889.063L261.053 851.138",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M729.827 251.919V400.373",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M804.054 326.145H655.6",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1996.25 893.489V1061.34",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2080.17 977.414H1912.33",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.82 1306.41C1556.99 1306.41 1582.26 1281.14 1582.26 1249.97C1582.26 1218.8 1556.99 1193.53 1525.82 1193.53C1494.65 1193.53 1469.38 1218.8 1469.38 1249.97C1469.38 1281.14 1494.65 1306.41 1525.82 1306.41Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1565.73 1289.88L1708.83 1432.93C1712.12 1436.22 1714.72 1440.1 1716.48 1444.4C1718.26 1448.68 1719.18 1453.27 1719.18 1457.91C1719.18 1462.55 1718.26 1467.14 1716.48 1471.43C1714.72 1475.72 1712.12 1479.61 1708.83 1482.89C1705.55 1486.17 1701.65 1488.78 1697.37 1490.55C1693.08 1492.32 1688.49 1493.24 1683.85 1493.24C1679.22 1493.24 1674.63 1492.32 1670.34 1490.55C1666.04 1488.78 1662.16 1486.17 1658.88 1482.89L1586.79 1410.79C1583.51 1407.51 1579.61 1404.91 1575.33 1403.13C1571.04 1401.37 1566.45 1400.45 1561.81 1400.45C1557.18 1400.45 1552.59 1401.37 1548.3 1403.13C1544 1404.91 1540.12 1407.51 1536.84 1410.79C1533.55 1414.08 1530.95 1417.96 1529.17 1422.26C1527.41 1426.54 1526.49 1431.13 1526.49 1435.77C1526.49 1440.41 1527.41 1445 1529.17 1449.28C1530.95 1453.58 1533.55 1457.47 1536.84 1460.75L1640.57 1564.49",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1797.13 1810.6L1771.72 1785.19",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1873.94 1708.37L1904.55 1677.77L1791.29 1564.51C1771.29 1544.51 1744.17 1533.28 1715.89 1533.28C1687.62 1533.28 1660.5 1544.51 1640.5 1564.51C1620.5 1584.51 1609.27 1611.63 1609.27 1639.9C1609.27 1668.18 1620.5 1695.3 1640.5 1715.29L1753.76 1828.55L1784.37 1797.95",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1886.64 1721.07L1861.24 1695.67",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M991.822 878.034C1017.54 874.079 1066.33 861.225 1076.01 821.664C1078.74 808.088 1079.93 794.248 1079.54 780.407C1079.54 776.805 1079.61 773.227 1079.7 769.66C1065.14 773.415 1054.98 769.66 1050.76 755.535C1044.1 733.17 1054.29 678.106 1061.64 666.077C1073.01 647.314 1098.2 649.692 1103.4 677.176C1104.65 683.839 1107.79 700.506 1109.01 706.25C1110.7 702.978 1113.3 700.265 1116.5 698.442C1119.7 696.617 1123.36 695.76 1127.03 695.975C1136.65 697.893 1135.72 710.712 1128.78 718.469C1126.94 720.711 1124.61 722.511 1121.98 723.734C1119.35 724.956 1116.48 725.57 1113.58 725.531C1119.71 750.331 1128.69 774.341 1140.32 797.086C1162.69 839.39 1190.61 861.826 1225.41 865.169C1262.98 866.32 1300.38 870.595 1337.24 877.952C1345.48 879.729 1353.72 881.683 1361.96 883.755C1327.59 854.961 1295.78 823.237 1266.91 788.941C1219.74 730.287 1208.24 676.023 1163.61 637.097C1107.72 588.283 1019.87 590.355 1017.65 704.909C1016.92 743.176 1012.63 782.102 993.023 815.802C973.731 845.417 947.336 869.737 916.242 886.545C903.988 894.031 899.198 896.985 893.548 900.081C931.403 891.324 971.353 882.26 991.822 878.034Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.32 793.978C1087.48 780.82 1097.05 768.587 1107.86 757.488C1099.08 762.798 1089.61 766.888 1079.73 769.648C1079.63 773.179 1079.61 776.851 1079.57 780.394C1079.53 784.891 1079.47 789.434 1079.32 793.978Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M729.593 2070.19L820.946 1719.41C820.946 1719.41 915.266 1615.76 988.634 1528.54C1046.06 1460.27 1081.74 1410.57 1095.09 1391.37",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.55 1731.05L1318.84 1767.31",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.28 1219.26C1258.48 1288.48 1285.28 1323.25 1296.71 1399.65C1307.19 1469.62 1303.57 1603.02 1264.22 1757.3L1561.85 1997.32",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.21 1357.67C1097.21 1357.67 1091.8 1439.46 1091.79 1459.81C1099.36 1450.24 1116.45 1425 1116.45 1425C1112.86 1401.85 1106.39 1379.22 1097.21 1357.67Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1659.7 1996.25L1577.49 1937.76C1580.66 1982.95 1540.8 2045.63 1479.97 2071.95C1500.85 2092.76 1574.02 2164.43 1624.01 2197.49C1682.87 2236.39 1689.93 2233.23 1689.93 2233.23L1659.7 1996.25Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1634.16 1978.08L1665.39 2222.98",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M588.518 2034.97L562.622 2113.91C495.784 2135.64 436.81 2176.55 393.039 2231.54H725.837L759.431 2067.84C711.041 2075.74 633.706 2063.33 588.518 2034.97Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M416.663 2203.94H731.498",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1973.43 1142.15C1960.99 1125.22 1945 1111.2 1926.59 1101.09C1886.89 1076.44 1845.07 1055.35 1801.65 1038.07C1800.81 1074.83 1790.13 1110.7 1770.75 1141.94C1799.07 1157.32 1823.34 1184.31 1833 1190.7C1843.28 1197.55 1852.42 1189.94 1848.42 1180.6C1840.55 1167.43 1831.9 1154.74 1822.53 1142.6C1816.09 1132.94 1811.38 1106.42 1842.1 1109.9C1872.82 1113.37 1950.46 1143.11 1961.28 1148.42C1972.1 1153.73 1977.68 1148.57 1973.43 1142.15Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1932.27 1136.8C1936.3 1144.48 1942.86 1157.23 1946.91 1167C1947.66 1168.77 1947.67 1170.77 1946.97 1172.57C1946.25 1174.36 1944.86 1175.81 1943.1 1176.59C1940.85 1177.58 1938.34 1177.82 1935.95 1177.27C1933.55 1176.73 1931.4 1175.42 1929.81 1173.55C1907.71 1150.29 1882.91 1129.76 1855.92 1112.41",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1897.37 1143C1902.62 1153 1907.3 1163.3 1911.4 1173.83C1911.75 1174.78 1911.89 1175.78 1911.84 1176.79C1911.79 1177.79 1911.53 1178.77 1911.08 1179.67C1910.63 1180.57 1910.01 1181.37 1909.24 1182.02C1908.48 1182.66 1907.58 1183.15 1906.62 1183.44C1904.89 1183.97 1903.03 1183.92 1901.31 1183.32C1899.6 1182.72 1898.13 1181.58 1897.11 1180.09C1886.44 1165.35 1873.27 1152.6 1858.2 1142.42C1846.08 1133.32 1832.73 1126.01 1818.54 1120.69",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousal4);
export default __webpack_public_path__ + "static/media/Carousal_4.4ea015cb14ccb69754e1c904ca9ee359.svg";
export { ForwardRef as ReactComponent };